import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromAOM } from 'core/contexts/device-types';
import { SettingsTrainingSettingsContainer } from 'modules/settings/pods/settings-training-settings/settings-training-settings.container';

export const SettingsTrainingSettingsScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromAOM} source={DEVICE_TYPE_SOURCE.AOM}>
        <SettingsTrainingSettingsContainer />
    </DeviceTypesProvider>
);

export default SettingsTrainingSettingsScene;
